import { render, staticRenderFns } from "./HotGoods.vue?vue&type=template&id=58e936b9&scoped=true"
import script from "./HotGoods.vue?vue&type=script&lang=js"
export * from "./HotGoods.vue?vue&type=script&lang=js"
import style0 from "./HotGoods.vue?vue&type=style&index=0&id=58e936b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e936b9",
  null
  
)

export default component.exports